import { Card, Flex, Heading, TextField, Box } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { useBlogsManager } from '../blogs-manager.provider';

const BlogsMangerFiltersView = () => {
   const blogsManager = useBlogsManager();
   return (
      <Card m="3" className="slider-filters">
         <Flex direction="column" gap="2">
            <Heading as="h4" weight="medium" color="gray">
               Filters
            </Heading>
            <Box minWidth="300px">
               <TextField.Root
                  placeholder="Search by typing title or Created date"
                  size="3"
                  color="blue"
                  autoComplete="off"
                  onChange={(e) => blogsManager.onSearchChange(e.target.value)}
               />
            </Box>
         </Flex>
      </Card>
   );
};

export const BlogsMangerFilters = observer(BlogsMangerFiltersView);
